import axios from 'axios';
import InvoicePaymentLinkItem
  from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link-item';
import InvoicePaymentCountry from '@/domain/billing/entity/invoice-payment-link/invoice-payment-country';
import InvoicePaymentMethod from '@/domain/billing/entity/invoice-payment-link/invoice-payment-method';
import InvoicePaymentLink from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link';
import InvoicePaymentLinkResponse from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link-response';

export default class InvoicePaymentLinkService {
  public static getInvoicePaymentLinks(
    invoiceId: string,
    sort: string,
  ): Promise<InvoicePaymentLinkItem[]> {
    return axios.get(`/api/v1/invoices/${invoiceId}/payment`, { params: { sort } })
      .then(({ data }: any) => (data.map((it) => new InvoicePaymentLinkItem(it))));
  }

  public static getPaymentCountries(): Promise<InvoicePaymentCountry[]> {
    return axios.get('/api/v1/payment/countries').then(({ data }: any) => data.map((it) => new InvoicePaymentCountry(it)));
  }

  public static getPaymentMethods(country: string): Promise<InvoicePaymentMethod[]> {
    return axios.get('/api/v1/payment/methods', { params: { country } })
      .then(({ data }: any) => data.map((it) => new InvoicePaymentMethod(it)));
  }

  public static createPaymentLink(
    invoiceId: string,
    paymentLink: InvoicePaymentLink,
  ): Promise<InvoicePaymentLinkResponse> {
    return axios.post(`/api/v1/invoices/${invoiceId}/payment`, paymentLink.toRequest())
      .then(({ data }: any) => new InvoicePaymentLinkResponse(data));
  }
}
